import { useEffect, useState } from "react";

function Leaderboard() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const scores = JSON.parse(localStorage.getItem("leaderboard")) || [];

    scores.sort((a, b) => b.score - a.score);

    setData(scores);
  }, []);

  return (
    <div style={styles.container}>
      <h1>🏆 Leaderboard</h1>

      {data.length === 0 ? (
        <p>No data yet</p>
      ) : (
        data.map((item, index) => (
          <div key={index} style={styles.card}>
            <h3>#{index + 1}</h3>
            <p>Score: {item.score} ⭐</p>
            <p>Date: {item.date}</p>
          </div>
        ))
      )}
    </div>
  );
}

// 🔥 STYLES
const styles = {
  container: {
    padding: "30px",
    textAlign: "center",
    background: "#1e1e2f",
    minHeight: "100vh",
    color: "white",
  },

  card: {
    background: "rgba(255,255,255,0.1)",
    margin: "10px auto",
    padding: "15px",
    borderRadius: "12px",
    width: "300px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
    backdropFilter: "blur(10px)",
  },
};

export default Leaderboard;